import { render, staticRenderFns } from "./RiskPointList.vue?vue&type=template&id=84774eaa&scoped=true"
import script from "./RiskPointList.vue?vue&type=script&lang=js"
export * from "./RiskPointList.vue?vue&type=script&lang=js"
import style0 from "./RiskPointList.vue?vue&type=style&index=0&id=84774eaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84774eaa",
  null
  
)

export default component.exports